<template>
	<div class="tab-box">
		<div class="tab-name">{{tabName}}：</div>
		<!-- <div ref="tabs" :class="index==0?'tab-first active':'tab active'" v-for="(item, index) in StatusArr" :id="item.code" :key="item.id" @click="tabClick">{{ item.name }}</div> -->
	    <!-- <div>
			<el-tooltip content="清除"  placement="top">
				<el-button size="mini" type="warning" icon="el-icon-error" @click="cancelSelect" plain></el-button>
			</el-tooltip>
			<i class="el-icon-delete" @click="cancelSelect" title="清除选择"></i>
		</div> -->
		<el-select v-model="value" clearable placeholder="请选择" @change="getselect">
			<el-option
			v-for="item in StatusArr"
			:key="item.id"
			:label="item.name"
			:value="item.code">
			</el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: 'TabForSeach',
	props:{
		StatusArr:Array,
        tabName:String,
	},
	data() {
		return {
			codeArr:'',
			value:''
		};
	},
	watch:{
	},
	methods: {
		getselect(val) {
			console.log(val)
			this.codeArr=val
			this.$emit('handleStatus',this.codeArr)
		},
	},
	mounted() {}
};
</script>

<style lang="less">
.tab-box {
	// width: 100%;
	height: 32px;
	display: flex;
	flex-direction: row;

	div {
		// padding: 10px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		font-size: 12px;
		cursor: pointer;
	}
	.el-button{
		height: 24px;
		// width: 30px;
		text-align: center;
	}
	.tab{
		margin: 0 0 0 10px;
	}
	.tab-first{
		margin: 0;
	}
	.tab-name{
		font-size: 14px;
	}
	.active {
		background: #409eff;
		color: white;
		border-radius: 4px;
		font-size: 12px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/TabForSeach.vue